/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from "../util/Permission";

export default declareEntity({
    entity: "usedScenarios",
    graphQL: "UsedScenario",
    name: "Used Scenario",
    dynamoPrefix: 'org',
    storageType: 'central',
    writePermission: [
        Permission.PERM_EDIT_CHANNEL,
    ],
    fields: (types) => { return {
        id: {
            name: "Used Scenario ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            required: true,
            parent: true,
            filterable: true,
            hiddenCreate: true,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        scenarioDef: {
            name: "Scenario Definition",
            to: () => types['scenarioDefs'],
            type: "relation",
            required: true,
            hiddenCreate: true,
            defaultValue: (scenario) => {
                return scenario['scenarioDef_id'];
            },
        },
        scenario: {
            name: "Scenario",
            to: () => types['scenarios'],
            type: "relation",
            required: true,
            hiddenCreate: true,
            filterable: true,
            defaultValue: (scenario) => {
                return scenario['id'];
            },
        },
        usedChannels: {
            name: "Used Channels",
            type: "object",
            defaultValue: {},
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
            defaultValue: (scenarioDef) => {
                return scenarioDef['author_id'];
            },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
        scenarios2ChannelDefs: {
            type: 'oneToMany',
            export: false,
            to: types['scenarios2ChannelDefs'],
            foreignKeys: [
                {
                    from: "id",
                    to: "scenario_id"
                }
            ]
        },
    }; }
});
